import { Box, InputLabel, makeStyles, TextField, Typography, Button } from '@material-ui/core'
import React from 'react'
import { useState } from 'react'
import Modal from 'react-awesome-modal'
import {backend} from '../../../api'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const useStyles = makeStyles((theme) => ({
    label: {
        color: theme.palette.secondary.light,
        margin: '10px 0',
    },
    submitBtn:{
        color: theme.palette.secondary.light,
        backgroundColor: theme.palette.primary.main,
        width: 100,
        padding: 10,
        '&:hover':{
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.primary.main,
        }
    },
    modalContainer:{
        width: '90%',
        margin: '20px auto'
    }
}))

function ForgotPasswordModal(props) {
    const {visible, closeModal} = props
    const [email, setEmail] = useState('')
    const classes = useStyles()
    const handleForgotPassword = () => {
        const newItem = {
            email: email
        }
        backend
            .put('/user/password/forgot', newItem)
            .then((res) => {
                // console.log({'Response in Password Forgot': res})
                closeModal()
                Swal.fire({
                    title: 'Congratulations',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    text: 'Temporary Password sent on Email'
                }).then((result) => {
                   

                })
            })
            .catch((err) => {
                // console.log({'Error in Password Forgot': err})
                
                if(err.response){
                    toast.error(err.response.data.message)
                } else {
                    toast.error(err.message)
                }
            })
    }
    return (
        <Modal visible={visible} width="500" effect="fadeInUp" onClickAway={closeModal}>
            <div className={classes.modalContainer}>
                <Typography variant="h4" color="primary" mb={3}>Reset Password</Typography>
                <Box my={4}>
                    <InputLabel className={classes.label}>Enter Your Email Here</InputLabel>
                    <TextField type="email" variant="outlined" fullWidth value={email} onChange={(e) => setEmail(e.target.value)}  />
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Button onClick={closeModal}>Cancel</Button>
                    <Button className={classes.submitBtn} onClick={handleForgotPassword}>Reset</Button>
                </Box>
            </div>
            
        </Modal>
    )
}

export default ForgotPasswordModal
